const initialState: number[] = [];

const availableFieldReducer = (state = initialState, action: AvFieldType) => {
    switch (action.type) {
        case 'SET_AVAILABLE':
            return [...state, action.idx];
        case 'EMPTY_AVAILABLE':
            return [];

        default:
            return state;
    }
};
interface AvFieldType {
    type: string;
    idx: Number[];
}
export default availableFieldReducer;
